//PROD-V3-AZURE
export const FUNCTION_URL = 'https://digigemfunc.telecomitalia.it/api';
export const APPINSIGHTS_KEY = '6c1aca0c-4a31-40ad-8f97-daabb1188a02';
export const REDIRECT_URL = 'https://digigem.telecomitalia.it/login/';
export const LOGOUT_URL = 'https://digigem.telecomitalia.it/wp-login.php?action=logout';